import { FC } from 'react';

import { BottomPopup } from '@shared/components/BottomPopup';
import { Icon } from '@shared/components/icons';
import { checkIOS } from '@shared/utils/miscUtil';
import { RWebShare } from 'react-web-share';

import KakaoShareGiftButton from './KakaoShareGiftButton';

interface Props {
  openId: string;
  courtesyContent: string; // 답례글 내용
  linkUrl: string; // 쿠폰 교환 링크
  onShare?: () => void; // 공유 완료 시 콜백
}

export const GiftCouponShareModal: FC<Props> = function GiftCouponShareModal({
  openId,
  courtesyContent,
  linkUrl,
  onShare,
}) {
  const { ShareMessage, OtherApps } = Icon();

  // SMS용 텍스트 (답례글 + 링크)
  const smsText = `${courtesyContent}\n\n▼ 답례품 받기 ▼\n${linkUrl}`;
  const smsContent = smsText.replace(/\n/g, '%0D%0A');

  // 카카오 공유용 텍스트
  const kakaoText = courtesyContent;

  return (
    <BottomPopup openId={openId}>
      <div className="w-screen rounded-t-2xl bg-white px-9 pb-12 pt-6">
        <h2 className="text-center text-lg font-bold text-gray-800">답례품 전달하기</h2>

        <div className="flex justify-center gap-6 pt-6">
          {/* 문자 공유 */}
          <a
            href={checkIOS() ? `sms:&body=${smsContent}` : `sms:?body=${smsContent}`}
            onClick={() => onShare?.()}
          >
            <div className="flex h-[70px] w-[80px] flex-col items-center justify-center gap-2">
              <ShareMessage className="h-full w-full" />
              <p className="text-sm font-bold text-gray-700">문자</p>
            </div>
          </a>

          {/* 카카오톡 공유 */}
          <div
            className="flex h-[70px] w-[80px] flex-col items-center justify-center gap-2"
            onClick={() => onShare?.()}
          >
            <KakaoShareGiftButton
              content={kakaoText}
              linkUrl={linkUrl}
              buttonTitle="답례품 받기"
            />
            <p className="text-sm font-bold text-gray-700">카카오톡</p>
          </div>

          {/* 다른 앱 공유 */}
          <RWebShare
            data={{
              text: smsText,
              url: linkUrl,
              title: '답례품',
            }}
            onClick={() => onShare?.()}
          >
            <div className="flex h-[70px] w-[80px] flex-col items-center justify-center gap-2">
              <OtherApps />
              <p className="text-sm font-bold text-gray-700">다른 앱</p>
            </div>
          </RWebShare>
        </div>
      </div>
    </BottomPopup>
  );
};
